<template>
  <base-dialog
    max-width="500"
    data-testid="statechartDeleteDialog.delete-dialog"
    type="delete"
    dialog-id="statechartDeleteDialog"
    @complete-dialog="onDelete"
    @cancel-dialog="onCancel"
  >
    <template #content>
      <div v-if="batchCount && batchCount > 1">
        Are you sure you want to delete the <strong>{{ batchCount }} selected statecharts</strong>?
      </div>
      <div v-else>
        Are you sure you want to delete the statechart
        <strong>"{{ statechartName }}"</strong>?
      </div>
    </template>
    <template #footer>
      <v-btn-delete-action data-testid="statechartDeleteDialog.cancel-button" @click="onCancel">
        Cancel
      </v-btn-delete-action>
      <v-btn-delete-action-CTA data-testid="statechartDeleteDialog.delete-button" @click="onDelete">
        Delete
      </v-btn-delete-action-CTA>
    </template>
  </base-dialog>
</template>

<script setup lang="ts">
import BaseDialog from "../../shared/BaseDialog.vue";
import { StatechartsService } from "../services/statecharts/statecharts-service";
import { MessageEventBus } from "../../event-bus";
import { inject } from "vue";

const compProps = withDefaults(
  defineProps<{
    statechartModelId: string;
    statechartName: string;
    batchCount?: number;
  }>(),
  { batchCount: undefined }
);

const emit = defineEmits(["cancel", "deleted"]);

const cloudStatechartService: StatechartsService = inject<StatechartsService>("cloudStatechartService");

function onCancel() {
  emit("cancel");
}

async function onDelete() {
  await cloudStatechartService
    .deleteModel(compProps.statechartModelId)
    .then(() => {
      emit("deleted");
      MessageEventBus.emit("success", {
        text: "'" + compProps.statechartName + "' got deleted.",
        id: "statechart-wizard",
      });
    })
    .catch(() => {
      emit("cancel");
      MessageEventBus.emit("error", {
        text: "Deletion of '" + compProps.statechartName + "' failed.",
        id: "statechart-wizard",
      });
    });
}
</script>
